var map = {
	"./ad/Android.svg": "8511",
	"./ad/Black.svg": "b75b",
	"./ad/Compact.svg": "d7a5",
	"./ad/Dark.svg": "25af",
	"./ad/Deep.svg": "8a32",
	"./ad/Dialog.svg": "bc6d",
	"./ad/Facebook.svg": "88aa",
	"./ad/Frame.svg": "634c",
	"./ad/Grand.svg": "20bf",
	"./ad/Instagram.svg": "d9e7",
	"./ad/Large.svg": "e80d",
	"./ad/Large_1.svg": "9e94",
	"./ad/Large_2.svg": "fb67",
	"./ad/Large_3.svg": "1a2a",
	"./ad/Light.svg": "4c7c",
	"./ad/Mac.svg": "f330",
	"./ad/Main.svg": "fd9a",
	"./ad/Pink_Dating.svg": "fc95",
	"./ad/Small.svg": "e1a9",
	"./ad/Static_display.svg": "6b06",
	"./ad/Telegram.svg": "1608",
	"./ad/Twitter.svg": "16fa",
	"./ad/Whatsapp.svg": "3255",
	"./ad/White.svg": "7765",
	"./ad/White_Online.svg": "2c50",
	"./ad/Windows.svg": "fcbe",
	"./ad/animate/Float_Motion": "5d76",
	"./ad/animate/Float_Motion.json": "5d76",
	"./ad/animate/Pure_white": "647e",
	"./ad/animate/Pure_white.json": "647e",
	"./ad/animate/Purple_gradient": "98a8",
	"./ad/animate/Purple_gradient.json": "98a8",
	"./ad/animate/Ripple_effect": "69b0",
	"./ad/animate/Ripple_effect.json": "69b0",
	"./ad/animate/Ripple_effect_2": "3c99",
	"./ad/animate/Ripple_effect_2.json": "3c99",
	"./ad/animate/Spin_animation": "5814",
	"./ad/animate/Spin_animation.json": "5814",
	"./ad/animate/Twist_Notification": "85e3",
	"./ad/animate/Twist_Notification.json": "85e3",
	"./ad/iOS.svg": "0dec",
	"./ad/iOS_Dark.svg": "12b1",
	"./noAd/Android.svg": "881c",
	"./noAd/Black.svg": "653a",
	"./noAd/Compact.svg": "a42d",
	"./noAd/Dark.svg": "0e01",
	"./noAd/Deep.svg": "081e",
	"./noAd/Dialog.svg": "1c52",
	"./noAd/Facebook.svg": "f642",
	"./noAd/Frame.svg": "1af7",
	"./noAd/Grand.svg": "f916",
	"./noAd/Instagram.svg": "5b76",
	"./noAd/Large.svg": "dcc1",
	"./noAd/Large_1.svg": "7428",
	"./noAd/Large_2.svg": "24bb",
	"./noAd/Large_3.svg": "de35",
	"./noAd/Light.svg": "b792",
	"./noAd/Mac.svg": "edf4",
	"./noAd/Main.svg": "f1ae",
	"./noAd/Pink_Dating.svg": "6563",
	"./noAd/Small.svg": "0e7d",
	"./noAd/Static_display.svg": "5dbb",
	"./noAd/Telegram.svg": "7c0b",
	"./noAd/Twitter.svg": "8df0",
	"./noAd/Whatsapp.svg": "c7da",
	"./noAd/White.svg": "4cdc",
	"./noAd/White_Online.svg": "de27",
	"./noAd/Windows.svg": "5174",
	"./noAd/animate/Float_Motion": "c5de",
	"./noAd/animate/Float_Motion.json": "c5de",
	"./noAd/animate/Pure_white": "bada",
	"./noAd/animate/Pure_white.json": "bada",
	"./noAd/animate/Purple_gradient": "76fa",
	"./noAd/animate/Purple_gradient.json": "76fa",
	"./noAd/animate/Ripple_effect": "544e",
	"./noAd/animate/Ripple_effect.json": "544e",
	"./noAd/animate/Ripple_effect_2": "f5fd",
	"./noAd/animate/Ripple_effect_2.json": "f5fd",
	"./noAd/animate/Spin_animation": "c5e8",
	"./noAd/animate/Spin_animation.json": "c5e8",
	"./noAd/animate/Twist_Notification": "81c9",
	"./noAd/animate/Twist_Notification.json": "81c9",
	"./noAd/iOS.svg": "cfca",
	"./noAd/iOS_Dark.svg": "067f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2b1f";